import React from 'react'
import { ButtonSeeker, IconSeeker } from '@ui-seeker/core'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { setMappingFormData } from 'Pages/Admin/AdminMapping/@signals'

export default function CreateAdminMappingButton({ path }) {

	return <ButtonSeeker startIcon={<IconSeeker icon="plus"/>} onClick={() => setMappingFormData(path, `create-multi-company`)}>
		Create custom {path === MAPPING_TYPE.ACRISS ? "ACRISS" : "Category"}
	</ButtonSeeker>
}